export enum NotificationPriorityEnum {
  "Low" = 1,
  "Medium" = 2,
  "High" = 3,
  "Normal" = 4,
}

export enum NotificationStatusEnum {
  "Unread" = 1,
  "Read" = 2,
}

export enum NotificationTypeEnum {
  "Banner" = 1,
  "Popup" = 2,
  "In-App" = 3,
  "Email" = 4,
  "Announcement" = 5,
  "Marketing" = 6,
}

export enum UserNotificationEnum {
  // Default values
  DEFAULT_PRIORITY = NotificationPriorityEnum.Normal,
  DEFAULT_STATUS = NotificationStatusEnum.Unread,
  DEFAULT_TYPE = NotificationTypeEnum["In-App"],
}

